'use client'

import { div as MotionDiv } from 'motion/react-m'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import { ArrowLeft, Buildings } from '@/components/icons'
import { WorkspacePageContentHeading } from '@/components/layout/workspace-page-content-heading'
import { PublicPageShell } from '@/components/public/public-page-shell'
import { Button } from '@/components/ui/button'

function returnToPreviousPage() {
  window.history.back()
}

export default function NotFound() {
  const t = useTranslations('PageNotFound')
  const tWs = useTranslations('WorkspaceSwitcher')

  return (
    <PublicPageShell className="bg-background">
      <div className="w-full max-w-lg text-center">
        {/* 404 number */}
        <MotionDiv
          animate={{ opacity: 1, scale: 1 }}
          initial={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
        >
          <div aria-hidden="true" className="text-title-2xl text-muted-foreground/15 select-none">
            {t('code')}
          </div>
        </MotionDiv>

        {/* Content */}
        <MotionDiv
          animate={{ opacity: 1, y: 0 }}
          className="mt-4"
          initial={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.4, delay: 0.15 }}
        >
          <WorkspacePageContentHeading className="text-title-xl font-medium tracking-tight text-foreground">
            {t('title')}
          </WorkspacePageContentHeading>
          <p className="mt-3 text-subtitle-lg text-muted-foreground">{t('description')}</p>

          {/* Actions */}
          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            <Button nativeButton={false} render={<Link href="/workspace-not-found" />} size="lg">
              <Buildings className="me-2 h-4 w-4" />
              {tWs('switchWorkspace')}
            </Button>
            <Button onClick={returnToPreviousPage} size="lg" variant="outline">
              <ArrowLeft className="me-2 h-4 w-4 rtl:rotate-180" />
              {t('goBack')}
            </Button>
          </div>
        </MotionDiv>
      </div>
    </PublicPageShell>
  )
}
